import { capitalizeFirstLetter } from './StringTools'  

export function generateDisplayName(valueName){
    var title = ''
    if(valueName.includes("_")){
        const words = valueName.split('_')
        const capWords = words.map(capitalizeFirstLetter)
        title = capWords.join(' ')
    }
    else{
        title = capitalizeFirstLetter(valueName)
    }
    return title
}
